export default __webpack_public_path__ + "static/media/apple.df881029.png";